import {
    CONFIRMATION_REDIRECT_ACTION_PARAM,
    CONFIRMATION_REDIRECT_ACTION_VALUE,
    CONFIRMATION_REDIRECT_FROM_PARAM,
    CONFIRMATION_REDIRECT_FROM_VALUE
} from '@homeexchange/payment';

import Analytics from '../../utils/analytics';

export function handleBackFromPaymentConfirmation({
    conversation,
    user,
    replaceSearch,
    onPreapprovalSuccess,
    onFinalizeSuccess
}) {
    const params = new URLSearchParams(location.search);
    const from = params.get(CONFIRMATION_REDIRECT_FROM_PARAM);
    const action = params.get(CONFIRMATION_REDIRECT_ACTION_PARAM);

    if (
        from !== CONFIRMATION_REDIRECT_FROM_VALUE ||
        (action !== CONFIRMATION_REDIRECT_ACTION_VALUE.FINALIZE &&
            action !== CONFIRMATION_REDIRECT_ACTION_VALUE.PREAPPROVE)
    ) {
        return;
    }

    params.delete(CONFIRMATION_REDIRECT_FROM_PARAM);
    params.delete(CONFIRMATION_REDIRECT_ACTION_PARAM);
    replaceSearch(params.toString());

    if (action === CONFIRMATION_REDIRECT_ACTION_VALUE.PREAPPROVE) {
        if (conversation.getExchangeAsHost()) {
            onPreapprovalSuccess();
        }
        return;
    }

    Analytics.trackGTM('exchange_status', {
        event_data: {
            exchange_status: 'finalized',
            exchange_type: conversation.isMutual() ? 'reciprocal_exchange' : 'guest_point_exchange',
            collection: user.isCollection()
        }
    });
    onFinalizeSuccess();
    document.dispatchEvent(new CustomEvent('request_card', { detail: { view: 'infos' } }));
}
